import React, { useState } from "react";

// Model
import { pages } from "../../model/data";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import {
  IconButton,
  Box,
  Container,
  Link,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const MenuBar = () => {
  const { device } = useDevice();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container className={`vjc_main-menu_bar ${device}`} maxWidth="100%">
      <Box
        className="vjc_main-menu_bar-box"
        sx={{ flexGrow: 1, display: "flex" }}
      >
        {pages.map((page, index) => {
          return (
            <Link
              key={index}
              href={`#${page.replaceAll(/\s/g, "").toLocaleLowerCase()}`}
              sx={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", color: "#524C47" }}
            >
              {page}
            </Link>
          );
        })}
      </Box>

      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}

      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {pages.map((page, index) => {
          return (
            <MenuItem onClick={handleClose}>
              {" "}
              <Link
                key={index}
                href={`#${page.replaceAll(/\s/g, "").toLocaleLowerCase()}`}
                sx={{
                  color: "#524C47",
                  textDecoration: "none",
                  fontFamily: "Nunito Sans, sans-serif",
                }}
              >
                {page}
              </Link>
            </MenuItem>
          );
        })}
      </Menu>
    </Container>
  );
};
export default MenuBar;
